<script setup lang="ts">
const props = defineProps({
  col: {
    type: Object,
    default: () =>
      function () {
        return {
          keySearch: ''
        }
      }
  }
})
const emit = defineEmits(['dateQueryComponent', 'dateInstantQueryComponent'])
const { t } = useI18n()

const columnKeySearch = (col, at = '') => {
  if (col.keySearch) {
    if (at.length > 0) return col.keySearch + '_' + at
    return col.keySearch
  }
  if (at.length > 0) return col.key + '_' + at
  return col.key
}

const dateQuery = (e, colKey) => {
  emit('dateQueryComponent', e, colKey)
}

const dateInstantQueryComponent = (e, colKey) => {
  emit('dateInstantQueryComponent', e, colKey)
}
</script>
<template>
  <CDropdown auto-close="outside" direction="center" placement="bottom">
    <CDropdownToggle color="secondary" size="sm">{{ t('Options') }}</CDropdownToggle>
    <CDropdownMenu class="px-2 pt-1">
      <small>{{ t('Exact') }}:</small>
      <CInputGroup class="mb-2">
        <CFormInput
          aria-label="From"
          aria-describedby="from"
          type="date"
          @input="
            e => {
              dateQuery(e, columnKeySearch(col))
            }
          "
          @keypress="
            e => {
              dateInstantQueryComponent(e, columnKeySearch(col))
            }
          "
        ></CFormInput>
      </CInputGroup>

      <small>{{ t('From') }}:</small>
      <CInputGroup class="mb-0">
        <CFormInput
          aria-label="From"
          aria-describedby="from"
          type="date"
          @input="
            e => {
              dateQuery(e, columnKeySearch(col, 'from'))
            }
          "
          @keypress="
            e => {
              dateInstantQueryComponent(e, columnKeySearch(col, 'from'))
            }
          "
        ></CFormInput>
      </CInputGroup>
      <small>{{ t('To') }}:</small>
      <CInputGroup>
        <CFormInput
          type="date"
          @input="
            e => {
              dateQuery(e, columnKeySearch(col, 'to'))
            }
          "
          @keypress="
            e => {
              dateInstantQueryComponent(e, columnKeySearch(col, 'to'))
            }
          "
        ></CFormInput>
      </CInputGroup>
    </CDropdownMenu>
  </CDropdown>
</template>
<style>
.mt-15 {
  margin-top: -15px;
}
</style>
